import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ variables, palette, breakpoints }) => ({
  section1: {
    height: '765px',
    marginBottom: variables?.spacingI,
    [breakpoints.down('xs')]:{ 
      height:'478px',
    },
    ['&.page_type_manager']:{
      ['@media only screen and (max-width:400px)']: {
        height:'520px !important'
      }
    }
  },
  section2: {
    height: '232px',
    marginBottom: variables?.spacingJ,
    [breakpoints.down('xs')]:{ 
      height:'auto',
      marginBottom: variables?.spacingG,
    }
  },
  section3: {
    height: '206px',
    marginBottom: variables?.spacingH,
    [breakpoints.down('xs')]:{ 
      height:'auto',
      marginBottom: variables?.spacingI,
    },
  },
  section4: {
    height: '92px',
    marginBottom: variables?.spacingJ,
    [breakpoints.down('xs')]:{
      marginBottom: variables?.spacingI
    }
  },
  section5: {
    height: '331px',
    marginBottom: variables?.spacingJ,
    [breakpoints.down('xs')]:{ 
      marginBottom: variables?.spacingH,
    },
  },
  section6: {
    height: '328px',
    marginBottom: variables?.spacingJ,
    [breakpoints.down('xs')]: {
      height: 'auto',
    }
  },
  section7: {
    height: '449px',
    marginBottom: variables?.spacingJ,
    [breakpoints.down('xs')]:{
      height:'auto',
      marginBottom: variables?.spacingH,
    }
  },
  section8: {
    marginBottom:variables?.spacingJ,
    minHeight:'100px',
    [breakpoints.down('xs')]: {
      marginBottom:variables?.spacingI,
    }
  },
  section9: {
    height:'86px',
    [breakpoints.down('sm')]:{
      height:'auto',
    }
  }
}));

export default useStyles;
